/**
 * useTabLabel — strona nadaje własnej karcie powłoki etykietę z danych (np. nazwa kartoteki),
 * zamiast etykiety wyliczonej z samej ścieżki (`resolveTenantTabMeta`).
 *
 * Kartę wskazuje ścieżka panelu (`useLocation` zwraca ścieżkę KARTY — każdy panel ma własne
 * `<Routes location>`), a nie karta aktywna: panele są keep-alive. Poza powłoką kart (testy)
 * albo bez etykiety → nic nie robi.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useTabsOptional } from '@/contexts/TabContext';

export function useTabLabel(label: string | null | undefined): void {
  const tabCtx = useTabsOptional();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!tabCtx || !label) return;
    const myTab = tabCtx.tabs.find((tab) => tab.basePath === pathname);
    if (myTab && myTab.label !== label) tabCtx.updateTabLabel(myTab.id, label);
  }, [tabCtx, label, pathname]);
}
